import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MetricTrend from "../../metrics/metric-trend";
import MetricPartition from "../../metrics/metric-partition";
import MetricValue from "../../metrics/metric-value";
import { useApiTenant } from "../../../../api/api-tenant";
import { getTrendLabels, getLabels } from "../../../../helpers/metrics";
import useOnScreen from "../../../../helpers/on-screen";
import { metricColors } from "../../../../helpers/colors";
export default function AudiencesMetrics({ campaign_id, globalRange, setGlobalRange, globalStartDate, globalStartTime, globalEndDate, globalEndTime, isChosenGlobalCustomRange, setIsChosenGlobalCustomRange, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const ref = useRef(null);
    const onScreen = useOnScreen(ref, "-100px");
    const [wasOnScreen, setWasOnScreen] = useState(false);
    const [audiencesValue, setAudiencesValue] = useState(0);
    const [audiencesValueCachedAt, setAudiencesValueCachedAt] = useState("");
    const [audiencesValueRange, setAudiencesValuesRange] = useState("total");
    const [audiencesValueLoading, setAudiencesValueLoading] = useState(true);
    const [audiencesValueError, setAudiencesValueError] = useState(false);
    const [audiencesValueStartDate, setAudiencesValueStartDate] = useState("");
    const [audiencesValueEndDate, setAudiencesValueEndDate] = useState("");
    const [audiencesValueStartTime, setAudiencesValueStartTime] = useState("");
    const [audiencesValueEndTime, setAudiencesValueEndTime] = useState("");
    const [isChosenValueCustomRange, setIsChosenValueCustomRange] = useState(false);
    const [audiencesTrendLabels, setAudiencesTrendLabels] = useState([]);
    const [audiencesTrendCachedAt, setAudiencesTrendCachedAt] = useState("");
    const [audiencesTrendValues, setAudiencesTrendValues] = useState([]);
    const [audiencesTrendRange, setAudiencesTrendRange] = useState("last_7_days");
    const [audiencesTrendLoading, setAudiencesTrendLoading] = useState(true);
    const [audiencesTrendError, setAudiencesTrendError] = useState(false);
    const [audiencesStatusData, setAudiencesStatusData] = useState([]);
    const [audiencesStatusCachedAt, setAudiencesStatusCachedAt] = useState("");
    const [audiencesStatusRange, setAudiencesStatusRange] = useState("total");
    const [audiencesStatusLoading, setAudiencesStatusLoading] = useState(true);
    const [audiencesStatusError, setAudiencesStatusError] = useState(false);
    const [audiencesStatusStartDate, setAudiencesStatusStartDate] = useState("");
    const [audiencesStatusEndDate, setAudiencesStatusEndDate] = useState("");
    const [isChosenStatusCustomRange, setIsChosenStatusCustomRange] = useState(false);
    const [audiencesStatusStartTime, setAudiencesStatusStartTime] = useState("");
    const [audiencesStatusEndTime, setAudiencesStatusEndTime] = useState("");
    const [audiencesValueMetricsRefresh, setAudiencesValueMetricsRefresh] = useState(false);
    const [audiencesTrendMetricsRefresh, setAudiencesTrendMetricsRefresh] = useState(false);
    const [audiencesStatusMetricsRefresh, setAudiencesStatusMetricsRefresh] = useState(false);
    const getAudiencesValue = invalidateCache => {
        setAudiencesValueLoading(true);
        if (audiencesValueError)
            setAudiencesValueError(false);
        let startTime;
        let endTime;
        if (audiencesValueRange === "custom" &&
            audiencesValueStartDate !== "" &&
            audiencesValueEndDate !== "") {
            if (audiencesValueStartTime !== "") {
                startTime =
                    format(new Date(audiencesValueStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(audiencesValueStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(audiencesValueStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (audiencesValueEndTime !== "") {
                endTime =
                    format(new Date(audiencesValueEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(audiencesValueEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(audiencesValueEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("count", "leads", audiencesValueRange, undefined, undefined, "audience.campaign,audience.active", campaign_id + ",1", undefined, invalidateCache ? 1 : undefined, audiencesValueRange === "custom" ? startTime : undefined, audiencesValueRange === "custom" ? endTime : undefined)
            .then(response => {
            setAudiencesValue(response.data.count);
            setAudiencesValueCachedAt(response.data.cached_at);
            setAudiencesValueLoading(false);
        })
            .catch(error => {
            setAudiencesValueError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setAudiencesValueLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getAudiencesStatusValues = invalidateCache => {
        setAudiencesStatusLoading(true);
        if (audiencesStatusError)
            setAudiencesStatusError(false);
        let startTime;
        let endTime;
        if (audiencesStatusRange === "custom" &&
            audiencesStatusStartDate !== "" &&
            audiencesStatusEndDate !== "") {
            if (audiencesStatusStartTime !== "") {
                startTime =
                    format(new Date(audiencesStatusStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(audiencesStatusStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(audiencesStatusStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (audiencesStatusEndTime !== "") {
                endTime =
                    format(new Date(audiencesStatusEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(audiencesStatusEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(audiencesStatusEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "leads", audiencesStatusRange, "status", undefined, "audience.campaign,audience.active", campaign_id + ",1", undefined, invalidateCache ? 1 : undefined, audiencesStatusRange === "custom" ? startTime : undefined, audiencesStatusRange === "custom" ? endTime : undefined, "updated_at")
            .then(response => {
            let metricsData = [];
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort((a, b) => a.count - b.count)
                .reverse()
                .map((d, i) => {
                metricsData.push({ label: d.label, count: d.count, color: metricColors[i] });
            });
            setAudiencesStatusData(metricsData);
            setAudiencesStatusCachedAt(response.data.cached_at);
            setAudiencesStatusLoading(false);
        })
            .catch(error => {
            setAudiencesStatusError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setAudiencesStatusLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getAudiencesTrendValues = invalidateCache => {
        setAudiencesTrendLoading(true);
        if (audiencesTrendError)
            setAudiencesTrendError(false);
        let trendsLabels = getTrendLabels(audiencesTrendRange);
        let labels = getLabels(trendsLabels, audiencesTrendRange);
        setAudiencesTrendLabels(labels);
        let interval = audiencesTrendRange;
        let startDate;
        let endDate;
        if (audiencesTrendRange === "last_7_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 6), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        else if (audiencesTrendRange === "last_30_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 29), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        api.GET_metrics("trend", "leads", interval, undefined, undefined, "audience.campaign,audience.active", campaign_id + ",1", undefined, invalidateCache ? 1 : undefined, startDate, endDate)
            .then(response => {
            let values = [];
            trendsLabels.map(label => {
                if (response.data.data.find(a => a.date === label)) {
                    values.push(response.data.data.find(a => a.date === label).count);
                }
                else {
                    values.push(0);
                }
            });
            setAudiencesTrendValues(values);
            setAudiencesTrendCachedAt(response.data.cached_at);
            setAudiencesTrendLoading(false);
        })
            .catch(error => {
            setAudiencesTrendError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setAudiencesTrendLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (onScreen && !wasOnScreen)
            setWasOnScreen(true);
    }, [onScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (audiencesValueRange !== "custom") {
            setAudiencesValueStartDate("");
            setAudiencesValueEndDate("");
            setAudiencesValueStartTime("");
            setAudiencesValueEndTime("");
        }
        getAudiencesValue(undefined);
    }, [audiencesValueRange, wasOnScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        getAudiencesTrendValues(undefined);
    }, [audiencesTrendRange, wasOnScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (audiencesStatusRange !== "custom") {
            setAudiencesStatusStartDate("");
            setAudiencesStatusEndDate("");
            setAudiencesStatusStartTime("");
            setAudiencesStatusEndTime("");
        }
        getAudiencesStatusValues(undefined);
    }, [audiencesStatusRange, wasOnScreen]);
    useEffect(() => {
        if (setGlobalRange &&
            globalRange !== "none" &&
            (audiencesValueRange !== globalRange ||
                (audiencesValueRange === globalRange &&
                    (globalStartDate !== audiencesValueStartDate ||
                        globalStartTime !== audiencesValueStartTime ||
                        globalEndDate !== audiencesValueEndDate ||
                        globalEndTime !== audiencesValueEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenValueCustomRange &&
            audiencesValueStartDate !== "" &&
            audiencesValueEndDate !== "") {
            getAudiencesValue(undefined);
            setIsChosenValueCustomRange(false);
        }
    }, [isChosenValueCustomRange]);
    useEffect(() => {
        if (setGlobalRange &&
            globalRange !== "none" &&
            (audiencesStatusRange !== globalRange ||
                (audiencesStatusRange === globalRange &&
                    (globalStartDate !== audiencesStatusStartDate ||
                        globalStartTime !== audiencesStatusStartTime ||
                        globalEndDate !== audiencesStatusEndDate ||
                        globalEndTime !== audiencesStatusEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenStatusCustomRange &&
            audiencesStatusStartDate !== "" &&
            audiencesStatusEndDate !== "") {
            getAudiencesStatusValues(undefined);
            setIsChosenStatusCustomRange(false);
        }
    }, [isChosenStatusCustomRange]);
    useEffect(() => {
        if (audiencesStatusMetricsRefresh) {
            getAudiencesStatusValues(true);
            setAudiencesStatusMetricsRefresh(false);
        }
        else if (audiencesTrendMetricsRefresh) {
            getAudiencesTrendValues(true);
            setAudiencesTrendMetricsRefresh(false);
        }
        else if (audiencesValueMetricsRefresh) {
            getAudiencesValue(true);
            setAudiencesValueMetricsRefresh(false);
        }
    }, [audiencesValueMetricsRefresh, audiencesTrendMetricsRefresh, audiencesStatusMetricsRefresh]);
    useEffect(() => {
        if (globalRange && globalRange !== "none" && globalRange !== "custom") {
            if (audiencesValueRange !== globalRange ||
                (audiencesTrendRange !== globalRange &&
                    globalRange !== "day" &&
                    globalRange !== "yesterday" &&
                    globalRange !== "total") ||
                audiencesStatusRange !== globalRange) {
                setAudiencesValuesRange(globalRange);
                if (globalRange !== "day" &&
                    globalRange !== "yesterday" &&
                    globalRange !== "total") {
                    setAudiencesTrendRange(globalRange);
                }
                setAudiencesStatusRange(globalRange);
                if (wasOnScreen)
                    setWasOnScreen(false);
            }
        }
    }, [globalRange]);
    useEffect(() => {
        if (isChosenGlobalCustomRange &&
            globalRange &&
            globalRange === "custom" &&
            globalStartDate &&
            globalStartDate !== "" &&
            globalEndDate &&
            globalEndDate !== "") {
            if (wasOnScreen)
                setWasOnScreen(false);
            setAudiencesValueStartDate(globalStartDate);
            setAudiencesValueEndDate(globalEndDate);
            setAudiencesStatusStartDate(globalStartDate);
            setAudiencesStatusEndDate(globalEndDate);
            setAudiencesValueStartTime(globalStartTime ? globalStartTime : "");
            setAudiencesStatusStartTime(globalStartTime ? globalStartTime : "");
            setAudiencesValueEndTime(globalEndTime ? globalEndTime : "");
            setAudiencesStatusEndTime(globalEndTime ? globalEndTime : "");
            setAudiencesValuesRange(globalRange);
            setAudiencesStatusRange(globalRange);
        }
    }, [isChosenGlobalCustomRange]);
    return (_jsx(Box, Object.assign({ ref: ref, sx: {
            marginBottom: 4,
        } }, { children: _jsxs(Grid, Object.assign({ container: true, spacing: 4 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricValue, { title: t("campaigns.audiences.leads.leads"), value: audiencesValue, range: audiencesValueRange, setRange: setAudiencesValuesRange, isLoading: audiencesValueLoading, setIsLoading: setAudiencesValueLoading, cachedAt: audiencesValueCachedAt, refresh: audiencesValueMetricsRefresh, setRefresh: setAudiencesValueMetricsRefresh, startDate: audiencesValueStartDate, setStartDate: setAudiencesValueStartDate, endDate: audiencesValueEndDate, setEndDate: setAudiencesValueEndDate, startTime: audiencesValueStartTime, setStartTime: setAudiencesValueStartTime, endTime: audiencesValueEndTime, setEndTime: setAudiencesValueEndTime, setIsChosenCustomRange: setIsChosenValueCustomRange, globalRange: globalRange, setGlobalRange: setGlobalRange, isError: audiencesValueError }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricTrend, { title: t("campaigns.audiences.metrics.leads-trend"), label: t("campaigns.audiences.leads.leads"), labels: audiencesTrendLabels, values: audiencesTrendValues, range: audiencesTrendRange, setRange: setAudiencesTrendRange, isLoading: audiencesTrendLoading, setIsLoading: setAudiencesTrendLoading, cachedAt: audiencesTrendCachedAt, refresh: audiencesTrendMetricsRefresh, setRefresh: setAudiencesTrendMetricsRefresh, isError: audiencesTrendError }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricPartition, { title: t("campaigns.audiences.metrics.leads-status"), metricData: audiencesStatusData, range: audiencesStatusRange, setRange: setAudiencesStatusRange, isLoading: audiencesStatusLoading, setIsLoading: setAudiencesStatusLoading, cachedAt: audiencesStatusCachedAt, refresh: audiencesStatusMetricsRefresh, setRefresh: setAudiencesStatusMetricsRefresh, startDate: audiencesStatusStartDate, setStartDate: setAudiencesStatusStartDate, endDate: audiencesStatusEndDate, setEndDate: setAudiencesStatusEndDate, startTime: audiencesStatusStartTime, setStartTime: setAudiencesStatusStartTime, endTime: audiencesStatusEndTime, setEndTime: setAudiencesStatusEndTime, setIsChosenCustomRange: setIsChosenStatusCustomRange, globalRange: globalRange, setGlobalRange: setGlobalRange, metricType: "audience", isError: audiencesStatusError }) }))] })) })));
}
